import { hero } from '../../content/hero.js';
import { Icon } from '../Icon/Icon.js';

export function Hero() {
  return (
    <section
      style={{
        maxWidth: '1180px',
        margin: '0 auto',
        padding: 'clamp(46px,9vw,96px) clamp(18px,5vw,64px) 0',
        textAlign: 'center',
      }}
    >
      <div style={{ animation: 'cRise .6s cubic-bezier(.22,1,.36,1) both' }}>
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '7px',
            borderRadius: '999px',
            padding: '9px 16px',
            background: 'var(--glass)',
            border: '1px solid var(--edge)',
            backdropFilter: 'blur(var(--blur))',
            WebkitBackdropFilter: 'blur(var(--blur))',
            font: "700 11.5px/1 'Plus Jakarta Sans',sans-serif",
            letterSpacing: '.09em',
            color: 'var(--ink)',
          }}
        >
          <Icon name="school" style={{ fontSize: '15px', color: 'var(--yellow)' }} />
          {hero.eyebrow}
        </div>
      </div>
      <h1
        style={{
          margin: '24px auto 0',
          maxWidth: '15ch',
          font: "800 clamp(40px,8.4vw,84px)/.97 'Plus Jakarta Sans',sans-serif",
          letterSpacing: '-.042em',
          color: 'var(--ink)',
          textWrap: 'balance',
          animation: 'cRise .6s .06s cubic-bezier(.22,1,.36,1) both',
        }}
      >
        {hero.title}
      </h1>
      <p
        style={{
          margin: '20px auto 0',
          maxWidth: '46ch',
          font: "500 clamp(15px,1.8vw,18.5px)/1.55 'Plus Jakarta Sans',sans-serif",
          color: 'var(--muted)',
          textWrap: 'pretty',
          animation: 'cRise .6s .12s cubic-bezier(.22,1,.36,1) both',
        }}
      >
        {hero.subtitle}
      </p>
    </section>
  );
}
